import React, { useState, useEffect, useContext, useRef } from 'react';
import { adminService } from '../services/api';
import { ThemeContext } from '../App';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';

const IconSearch = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
);
const IconList = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="9" y1="6" x2="20" y2="6" /><line x1="9" y1="12" x2="20" y2="12" /><line x1="9" y1="18" x2="20" y2="18" />
        <line x1="4" y1="6" x2="4.01" y2="6" /><line x1="4" y1="12" x2="4.01" y2="12" /><line x1="4" y1="18" x2="4.01" y2="18" />
    </svg>
);
const IconEdit = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);
const IconPlus = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
);
const IconClose = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);
const IconCircle = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
    </svg>
);
const IconCheckCircle = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
    </svg>
);
const IconChevronLeft = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const IconChevronRight = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
    </svg>
);
const IconCopy = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
    </svg>
);
const IconTrash = ({ size = 14 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    </svg>
);
const IconAlertTriangle = ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
);
const IconDownload = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
    </svg>
);

const VEHICLE_TYPES = ['Sedan', 'SUV', 'Pickup Truck', 'Motorcycle', 'Van', 'Bus', 'Truck', 'Other'];
const STATUSES = ['In Process', 'At Dealer', 'At LTO'];
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const STATUS_COLORS = {
    'Available': { color: '#10b981', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.25)' },
    'At LTO':    { color: '#3b82f6', bg: 'rgba(59,130,246,0.12)', border: 'rgba(59,130,246,0.25)' },
    'At Dealer': { color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.25)' },
    'In Process':{ color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)', border: 'rgba(139,92,246,0.25)' },
};

const emptyForm = {
    mv_file_number: '', site_code: '', site_name: '', plate_number: '', owner_name: '',
    vehicle_type: '', brand: '', model: '', color: '',
    status: 'At Dealer', claim_location: '', remarks: '', assigned_dealer_id: '',
};

function getPageNumbers(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    if (current <= 4) return [1, 2, 3, 4, 5, '...', total];
    if (current >= total - 3) return [1, '...', total - 4, total - 3, total - 2, total - 1, total];
    return [1, '...', current - 1, current, current + 1, '...', total];
}

const normalizePlate = (p) => p ? p.toUpperCase().replace(/\s/g, '') : '';

export default function AdminPlates() {
    const { theme } = useContext(ThemeContext);
    const role = localStorage.getItem('platex_role') || 'administrator';
    const mySiteCode = localStorage.getItem('platex_site_code') || '';

    const canAdd    = role === 'administrator' || role === 'lto';
    const canEdit   = role === 'administrator' || role === 'lto';
    const canDelete = role === 'administrator';
    const canClaim  = role === 'administrator' || role === 'dealer';

    const [plates, setPlates]         = useState([]);
    const [loading, setLoading]       = useState(true);
    const [search, setSearch]         = useState('');
    const [page, setPage]             = useState(1);
    const [pageSize, setPageSize]     = useState(10);
    const [total, setTotal]           = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [showModal, setShowModal]   = useState(false);
    const [selected, setSelected]     = useState(null);
    const [form, setForm]             = useState(emptyForm);
    const [saving, setSaving]         = useState(false);
    const [dealers, setDealers]       = useState([]);
    const [dupFilter, setDupFilter]   = useState(false);
    const [claimMatch, setClaimMatch] = useState(''); // '', 'same', 'different' — only meaningful when dupFilter is on
    const [mvMatch, setMvMatch]       = useState(''); // '', 'same', 'different' — only meaningful when dupFilter is on
    const [claimingIds, setClaimingIds] = useState(new Set());
    // selectedIds persists across page/page-size changes so a user can build up a
    // selection spanning multiple pages before bulk-deleting. selectedRecords keeps
    // a snapshot of each selected row's data (captured at selection time) purely so
    // the bulk-delete confirm modal can list rows that aren't on the current page.
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [selectedRecords, setSelectedRecords] = useState(new Map());
    const [showBulkConfirm, setShowBulkConfirm] = useState(false);
    const [bulkDeleting, setBulkDeleting] = useState(false);
    const [exporting, setExporting] = useState(false);
    // Drag-to-resize column widths, keyed by column key (not label — labels
    // don't change, but which columns are shown does, based on role/dupFilter).
    // Populated lazily with each column's defaultWidth the first time it's resized.
    const [colWidths, setColWidths] = useState({});
    const resizingRef = useRef(null);

    const searchTimeout = useRef(null);
    // Guards against out-of-order responses: these queries can vary wildly in
    // latency (a cold-cache duplicates query can take far longer than a plain
    // list fetch), so an older request can resolve after a newer one. Only the
    // response matching the most recently issued request is ever applied.
    const fetchIdRef = useRef(0);

    // Initial load only — every subsequent fetch is triggered explicitly by the
    // action that caused it (page click, search, dup-filter toggle, page size),
    // so each user action results in exactly one request instead of two.
    useEffect(() => {
        fetchPlates('', 1, false, pageSize, '', '');
        return () => { if (searchTimeout.current) clearTimeout(searchTimeout.current); };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Selection intentionally survives page/page-size changes (see note above) —
    // only reset it when the filter criteria actually changes the working set.
    useEffect(() => { setSelectedIds(new Set()); setSelectedRecords(new Map()); }, [dupFilter, claimMatch, mvMatch, search]);

    useEffect(() => {
        adminService.getDealers().then(r => setDealers(r.data.data)).catch(() => {});
    }, []);

    const fetchPlates = async (q = '', p = 1, dup = false, size = 10, claim = '', mv = '') => {
        const thisFetchId = ++fetchIdRef.current;
        setLoading(true);
        try {
            const res = dup
                ? await adminService.getAll(q, p, size, 'plate', '', claim, mv)
                : await adminService.getAll(q, p, size, '');
            if (thisFetchId !== fetchIdRef.current) return; // a newer request has since been issued — ignore this stale response
            setPlates(res.data.data);
            setTotal(res.data.total);
            setTotalPages(res.data.totalPages);
        } catch {
            if (thisFetchId !== fetchIdRef.current) return;
            toast.error('Failed to load records');
        } finally {
            if (thisFetchId === fetchIdRef.current) setLoading(false);
        }
    };

    const handleSearch = (e) => {
        const q = e.target.value;
        setSearch(q);
        setPage(1);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            fetchPlates(q, 1, dupFilter, pageSize, claimMatch, mvMatch);
        }, 350);
    };

    const handleDupFilter = () => {
        const next = !dupFilter;
        setDupFilter(next);
        setPage(1);
        const nextClaimMatch = next ? claimMatch : '';
        const nextMvMatch = next ? mvMatch : '';
        if (!next) { setClaimMatch(''); setMvMatch(''); }
        fetchPlates(search, 1, next, pageSize, nextClaimMatch, nextMvMatch);
    };

    const handleClaimMatch = (value) => {
        const next = claimMatch === value ? '' : value;
        setClaimMatch(next);
        setPage(1);
        fetchPlates(search, 1, dupFilter, pageSize, next, mvMatch);
    };

    const handleMvMatch = (value) => {
        const next = mvMatch === value ? '' : value;
        setMvMatch(next);
        setPage(1);
        fetchPlates(search, 1, dupFilter, pageSize, claimMatch, next);
    };

    const handlePageSize = (size) => {
        setPageSize(size);
        setPage(1);
        fetchPlates(search, 1, dupFilter, size, claimMatch, mvMatch);
    };

    const goToPage = (p) => {
        if (p < 1 || p > totalPages || p === page) return;
        setPage(p);
        fetchPlates(search, p, dupFilter, pageSize, claimMatch, mvMatch);
    };

    const openAdd = () => {
        setSelected(null);
        setForm({ ...emptyForm, site_code: mySiteCode });
        setShowModal(true);
    };

    const openEdit = (plate) => {
        setSelected(plate);
        setForm({ ...emptyForm, ...plate, assigned_dealer_id: plate.assigned_dealer_id || '' });
        setShowModal(true);
    };

    const handle = (e) => {
        const { name, value } = e.target;
        setForm(f => ({
            ...f,
            [name]: value,
            ...(name === 'status' && value === 'In Process' ? { claim_location: '' } : {}),
            ...(name === 'status' && value !== 'At Dealer'  ? { assigned_dealer_id: '' } : {}),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            if (selected) {
                await adminService.update(selected.id, form);
                toast.success('Record updated!');
                fetchPlates(search, page, dupFilter, pageSize, claimMatch, mvMatch);
            } else {
                await adminService.create(form);
                toast.success('Record added!');
                setPage(1);
                fetchPlates(search, 1, dupFilter, pageSize, claimMatch, mvMatch);
            }
            setShowModal(false);
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong');
        } finally {
            setSaving(false);
        }
    };

    const handleToggleClaim = async (id, current) => {
        setClaimingIds(prev => new Set([...prev, id]));
        try {
            const res = await adminService.setClaimed(id, !current);
            setPlates(prev => prev.map(p => p.id === id ? { ...p, is_claimed: res.data.data.is_claimed } : p));
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to update claimed status');
        } finally {
            setClaimingIds(prev => { const next = new Set(prev); next.delete(id); return next; });
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this plate record?')) return;
        try {
            await adminService.delete(id);
            toast.success('Record deleted');
            const newPage = plates.length === 1 && page > 1 ? page - 1 : page;
            setPage(newPage);
            fetchPlates(search, newPage, dupFilter, pageSize, claimMatch, mvMatch);
        } catch {
            toast.error('Failed to delete record');
        }
    };

    const toggleSelectOne = (id, record) => {
        setSelectedIds(prev => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
        setSelectedRecords(prev => {
            const next = new Map(prev);
            next.has(id) ? next.delete(id) : next.set(id, record);
            return next;
        });
    };

    // Only adds/removes the CURRENT page's rows — selections from other pages
    // (already in selectedIds/selectedRecords) are left untouched either way.
    const toggleSelectAll = () => {
        const allOnPageSelected = displayPlates.length > 0 && displayPlates.every(p => selectedIds.has(p.id));
        setSelectedIds(prev => {
            const next = new Set(prev);
            displayPlates.forEach(p => allOnPageSelected ? next.delete(p.id) : next.add(p.id));
            return next;
        });
        setSelectedRecords(prev => {
            const next = new Map(prev);
            displayPlates.forEach(p => allOnPageSelected ? next.delete(p.id) : next.set(p.id, p));
            return next;
        });
    };

    const handleBulkDelete = async () => {
        if (!selectedIds.size) return;
        setBulkDeleting(true);
        try {
            const ids = [...selectedIds];
            const res = await adminService.bulkDelete(ids);
            toast.success(res.data.message || `${ids.length} record(s) deleted`);
            setShowBulkConfirm(false);
            setSelectedIds(new Set());
            setSelectedRecords(new Map());
            const deletedOnThisPage = ids.filter(id => plates.some(p => p.id === id)).length;
            const remaining = plates.length - deletedOnThisPage;
            const newPage = remaining <= 0 && page > 1 ? page - 1 : page;
            setPage(newPage);
            fetchPlates(search, newPage, dupFilter, pageSize, claimMatch, mvMatch);
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to delete selected records');
        } finally {
            setBulkDeleting(false);
        }
    };

    const handleExport = async () => {
        setExporting(true);
        try {
            const res = await adminService.exportExcel(search, 'plate', '', claimMatch, mvMatch);
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = `plates-export-${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch {
            toast.error('Failed to export records');
        } finally {
            setExporting(false);
        }
    };

    const MIN_COL_WIDTH = 60;
    const handleColResizeStart = (key, defaultWidth) => (e) => {
        e.preventDefault();
        resizingRef.current = {
            key,
            startX: e.clientX,
            startWidth: colWidths[key] ?? defaultWidth,
        };
        document.addEventListener('mousemove', handleColResizeMove);
        document.addEventListener('mouseup', handleColResizeEnd);
    };
    const handleColResizeMove = (e) => {
        if (!resizingRef.current) return;
        const { key, startX, startWidth } = resizingRef.current;
        const next = Math.max(MIN_COL_WIDTH, startWidth + (e.clientX - startX));
        setColWidths(prev => ({ ...prev, [key]: next }));
    };
    const handleColResizeEnd = () => {
        resizingRef.current = null;
        document.removeEventListener('mousemove', handleColResizeMove);
        document.removeEventListener('mouseup', handleColResizeEnd);
    };
    // Drag can be left mid-flight if the component unmounts (route change) —
    // make sure the document-level listeners don't outlive the page.
    useEffect(() => () => {
        document.removeEventListener('mousemove', handleColResizeMove);
        document.removeEventListener('mouseup', handleColResizeEnd);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const inputStyle = {
        background: theme.bgInput, border: `1px solid ${theme.borderInput}`,
        borderRadius: '8px', color: theme.textPrimary,
        fontSize: '0.875rem', padding: '9px 12px', width: '100%', outline: 'none',
    };
    const labelStyle = {
        display: 'block', color: theme.textMuted, fontSize: '0.72rem',
        fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '6px',
    };

    const pageNumbers = getPageNumbers(page, totalPages);
    const firstItem = total === 0 ? 0 : (page - 1) * pageSize + 1;
    const lastItem  = Math.min(page * pageSize, total);

    const showSiteCode = role !== 'dealer';
    const showActions  = canEdit || canDelete;

    const displayPlates = dupFilter
        ? [...plates].sort((a, b) => {
            const ka = normalizePlate(a.plate_number);
            const kb = normalizePlate(b.plate_number);
            if (ka < kb) return -1;
            if (ka > kb) return 1;
            return a.id - b.id;
        })
        : plates;

    const mvGroupIndex = {};
    let _groupCounter = 0;
    if (dupFilter) {
        displayPlates.forEach(p => {
            const key = normalizePlate(p.plate_number);
            if (key && !(key in mvGroupIndex)) mvGroupIndex[key] = _groupCounter++;
        });
    }

    const showBulkSelect = dupFilter && canDelete;

    // key/defaultWidth per column, independent of role-based visibility, so
    // colWidths (keyed by these) survives the column set changing shape.
    const columnDefs = [
        { key: 'mv', label: 'MV File No.', defaultWidth: 150 },
        ...(showSiteCode ? [
            { key: 'siteCode', label: 'Site Code', defaultWidth: 100 },
            { key: 'siteName', label: 'Site Name', defaultWidth: 150 },
        ] : []),
        { key: 'owner', label: 'Owner', defaultWidth: 150 },
        { key: 'plate', label: 'Plate No.', defaultWidth: 110 },
        { key: 'vehicle', label: 'Vehicle', defaultWidth: 140 },
        { key: 'status', label: 'Status', defaultWidth: 110 },
        { key: 'claimLocation', label: 'Claim Location', defaultWidth: 200 },
        { key: 'dealer', label: 'Dealer', defaultWidth: 150 },
        { key: 'updated', label: 'Updated', defaultWidth: 100 },
        ...(canClaim   ? [{ key: 'claimed', label: 'Claimed', defaultWidth: 120 }]  : []),
        ...(showActions ? [{ key: 'actions', label: 'Actions', defaultWidth: 130 }] : []),
    ];

    return (
        <div>
            {/* Header */}
            <div style={{
                background: theme.bgHeader, borderBottom: `1px solid ${theme.border}`,
                padding: '24px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
                <div>
                    <h1 style={{
                        fontFamily: 'Rajdhani, sans-serif', fontWeight: 700,
                        fontSize: '1.6rem', margin: 0, color: theme.textPrimary,
                    }}>Plate Records</h1>
                    <p style={{ color: theme.textMuted, margin: '4px 0 0', fontSize: '0.875rem' }}>
                        {role === 'lto'
                            ? `Showing records for site code: ${mySiteCode || '—'}`
                            : 'Manage all vehicle plate records'}
                    </p>
                </div>
                {canAdd && (
                    <button onClick={openAdd} style={{
                        display: 'flex', alignItems: 'center', gap: '6px',
                        background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                        border: 'none', borderRadius: '8px', color: 'white',
                        padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem',
                    }}>
                        <IconPlus size={14} /> Add Record
                    </button>
                )}
            </div>

            <div style={{ padding: '16px 20px' }}>

                {/* Search + duplicate filter toggle */}
                <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1, minWidth: '240px', position: 'relative' }}>
                        <span style={{
                            position: 'absolute', left: '12px', top: '50%',
                            transform: 'translateY(-50%)', color: theme.textMuted,
                            display: 'flex', alignItems: 'center',
                        }}>
                            <IconSearch size={16} />
                        </span>
                        <input
                            value={search} onChange={handleSearch}
                            placeholder="Search by MV File No., plate, owner, brand, model, color, status, site..."
                            style={{ ...inputStyle, paddingLeft: '36px' }}
                        />
                    </div>
                    <button
                        onClick={handleDupFilter}
                        disabled={loading}
                        title={loading ? 'Please wait for the current results to finish loading' : undefined}
                        style={{
                            display: 'flex', alignItems: 'center', gap: '6px',
                            padding: '9px 14px', borderRadius: '8px',
                            border: `1px solid ${dupFilter ? '#f59e0b' : theme.border}`,
                            background: dupFilter ? 'rgba(245,158,11,0.12)' : 'transparent',
                            color: dupFilter ? '#f59e0b' : theme.textMuted,
                            fontSize: '0.82rem', fontWeight: dupFilter ? 600 : 400,
                            cursor: loading ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap',
                            opacity: loading ? 0.6 : 1,
                        }}
                    >
                        <IconCopy size={14} />
                        Duplicates
                        {dupFilter && (
                            <span style={{
                                background: '#f59e0b', color: '#fff',
                                borderRadius: '10px', fontSize: '0.62rem',
                                fontWeight: 700, padding: '1px 6px', letterSpacing: '0.05em',
                            }}>ON</span>
                        )}
                    </button>
                </div>

                {/* Duplicate mode hint */}
                {dupFilter && (
                    <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px',
                        marginBottom: '10px', flexWrap: 'wrap',
                        padding: '8px 12px', borderRadius: '8px',
                        background: 'rgba(245,158,11,0.07)', border: '1px solid rgba(245,158,11,0.22)',
                        fontSize: '0.78rem', color: '#d97706',
                    }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                            <IconCopy size={13} />
                            {mvMatch === 'different'
                                ? 'Showing duplicate Plate Numbers attached to more than one MV File Number — often a plate that was released, went unclaimed, and got re-issued to a different owner without closing out the old record.'
                                : mvMatch === 'same'
                                ? 'Showing duplicate Plate Numbers where every copy shares the same MV File Number — a plain double-entry of the same record.'
                                : claimMatch === 'same'
                                ? 'Showing duplicate Plate Numbers where every copy has the same Claim Location — usually safe re-entries to clean up.'
                                : claimMatch === 'different'
                                ? 'Showing duplicate Plate Numbers where the Claim Location differs between copies — review before deleting, the plate may have actually moved.'
                                : 'Showing records with a duplicate Plate Number. Matching pairs are displayed as adjacent rows.'}
                            {canDelete && ' Check the ones you want to remove, review, then delete together.'}
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                                onClick={handleExport}
                                disabled={exporting || loading}
                                title={loading ? 'Please wait for the current results to finish loading' : 'Download the currently filtered duplicate records as an Excel file'}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '6px',
                                    background: 'rgba(37,99,235,0.1)', border: '1px solid rgba(37,99,235,0.3)',
                                    borderRadius: '7px', color: '#2563eb',
                                    padding: '6px 12px', cursor: (exporting || loading) ? 'not-allowed' : 'pointer',
                                    fontSize: '0.78rem', fontWeight: 700, whiteSpace: 'nowrap',
                                    opacity: (exporting || loading) ? 0.6 : 1,
                                }}
                            >
                                <IconDownload size={13} /> {exporting ? 'Exporting...' : 'Export to Excel'}
                            </button>
                            {canDelete && selectedIds.size > 0 && (
                                <button
                                    onClick={() => setShowBulkConfirm(true)}
                                    disabled={loading}
                                    title={loading ? 'Please wait for the current results to finish loading' : undefined}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '6px',
                                        background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.35)',
                                        borderRadius: '7px', color: '#ef4444',
                                        padding: '6px 12px', cursor: loading ? 'not-allowed' : 'pointer', fontSize: '0.78rem', fontWeight: 700,
                                        whiteSpace: 'nowrap', opacity: loading ? 0.6 : 1,
                                    }}
                                >
                                    <IconTrash size={13} /> Delete Selected ({selectedIds.size})
                                </button>
                            )}
                        </div>
                    </div>
                )}

                {/* Duplicate-cleanup refinement filters — narrow the duplicate-plate set by
                    whether Claim Location and/or MV File Number match across copies.
                    'Different MV File Number' catches the recurring human-error case: a
                    plate released, never claimed, then re-issued under a new MV File
                    Number without the old record ever being closed out. Dropdowns (not
                    buttons) to keep this to one compact row. */}
                {dupFilter && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px', flexWrap: 'wrap' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '0.72rem', color: theme.textMuted, fontWeight: 600, letterSpacing: '0.03em' }}>
                                Claim Location:
                            </span>
                            <select
                                value={claimMatch}
                                onChange={(e) => handleClaimMatch(e.target.value)}
                                disabled={loading}
                                title={loading ? 'Please wait for the current results to finish loading' : undefined}
                                style={{
                                    background: theme.bgInput, border: `1px solid ${claimMatch ? '#f59e0b' : theme.borderInput}`,
                                    borderRadius: '8px', color: claimMatch ? '#d97706' : theme.textPrimary,
                                    fontSize: '0.78rem', fontWeight: claimMatch ? 700 : 400,
                                    padding: '5px 10px', cursor: loading ? 'not-allowed' : 'pointer', outline: 'none',
                                    opacity: loading ? 0.6 : 1,
                                }}
                            >
                                <option value="">All duplicates</option>
                                <option value="same">Same location</option>
                                <option value="different">Different location</option>
                            </select>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '0.72rem', color: theme.textMuted, fontWeight: 600, letterSpacing: '0.03em' }}>
                                MV File Number:
                            </span>
                            <select
                                value={mvMatch}
                                onChange={(e) => handleMvMatch(e.target.value)}
                                disabled={loading}
                                title={loading ? 'Please wait for the current results to finish loading' : undefined}
                                style={{
                                    background: theme.bgInput, border: `1px solid ${mvMatch ? '#f59e0b' : theme.borderInput}`,
                                    borderRadius: '8px', color: mvMatch ? '#d97706' : theme.textPrimary,
                                    fontSize: '0.78rem', fontWeight: mvMatch ? 700 : 400,
                                    padding: '5px 10px', cursor: loading ? 'not-allowed' : 'pointer', outline: 'none',
                                    opacity: loading ? 0.6 : 1,
                                }}
                            >
                                <option value="">All duplicates</option>
                                <option value="same">Same MV File Number</option>
                                <option value="different">Different MV File Number</option>
                            </select>
                        </div>
                    </div>
                )}

                {/* Table card */}
                <div style={{
                    background: theme.bgCard,
                    border: `1px solid ${dupFilter ? 'rgba(245,158,11,0.35)' : theme.border}`,
                    borderRadius: '12px', overflow: 'hidden',
                    boxShadow: theme.dark ? 'none' : '0 1px 4px rgba(0,0,0,0.06)',
                }}>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
                            <div style={{
                                width: '32px', height: '32px',
                                border: '3px solid rgba(59,130,246,0.15)',
                                borderTopColor: '#3b82f6', borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite',
                            }} />
                        </div>
                    ) : plates.length === 0 ? (
                        <div style={{ padding: '60px', textAlign: 'center', color: theme.textMuted }}>
                            <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center' }}>
                                <IconList size={40} />
                            </div>
                            <div>
                                {dupFilter
                                    ? 'No duplicate records found.'
                                    : canAdd ? 'No records found. Add your first plate record!' : 'No records assigned to you yet.'}
                            </div>
                        </div>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem', tableLayout: 'fixed' }}>
                                <colgroup>
                                    {showBulkSelect && <col style={{ width: '40px' }} />}
                                    {columnDefs.map(col => (
                                        <col key={col.key} style={{ width: `${colWidths[col.key] ?? col.defaultWidth}px` }} />
                                    ))}
                                </colgroup>
                                <thead>
                                <tr>
                                    {showBulkSelect && (
                                        <th style={{
                                            padding: '10px 12px', textAlign: 'left',
                                            borderBottom: `1px solid ${theme.border}`,
                                            background: theme.bgCard,
                                        }}>
                                            <input
                                                type="checkbox"
                                                checked={displayPlates.length > 0 && displayPlates.every(p => selectedIds.has(p.id))}
                                                onChange={toggleSelectAll}
                                                style={{ cursor: 'pointer', width: '15px', height: '15px' }}
                                                title="Select all on this page"
                                            />
                                        </th>
                                    )}
                                    {columnDefs.map(col => (
                                        <th key={col.key} style={{
                                            position: 'relative',
                                            padding: '10px 12px', textAlign: 'left',
                                            color: theme.textMuted, fontSize: '0.68rem',
                                            fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase',
                                            borderBottom: `1px solid ${theme.border}`,
                                            background: theme.bgCard, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                        }}>
                                            {col.label}
                                            {/* Drag-to-resize handle — spreadsheet-style column resizing */}
                                            <div
                                                onMouseDown={handleColResizeStart(col.key, col.defaultWidth)}
                                                title="Drag to resize column"
                                                style={{
                                                    position: 'absolute', top: 0, right: 0, bottom: 0, width: '6px',
                                                    cursor: 'col-resize', userSelect: 'none',
                                                }}
                                                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(59,130,246,0.3)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                                            />
                                        </th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {displayPlates.map((p) => {
                                    const sc       = STATUS_COLORS[p.status] || STATUS_COLORS['In Process'];
                                    // No fixed maxWidth here anymore — the column's actual width now comes
                                    // from colWidths/colgroup (drag-to-resize), this just keeps overflow clipped.
                                    const truncate = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
                                    const groupIdx = dupFilter ? (mvGroupIndex[normalizePlate(p.plate_number)] ?? 0) : 0;
                                    const isSelected = selectedIds.has(p.id);
                                    const groupBg  = isSelected
                                        ? (theme.dark ? 'rgba(239,68,68,0.14)' : 'rgba(254,226,226,0.7)')
                                        : dupFilter
                                        ? (groupIdx % 2 === 0
                                            ? (theme.dark ? 'rgba(245,158,11,0.07)' : 'rgba(254,252,232,0.6)')
                                            : (theme.dark ? 'rgba(59,130,246,0.06)' : 'rgba(239,246,255,0.6)'))
                                        : 'transparent';

                                    return (
                                        <React.Fragment key={p.id}>
                                            <tr style={{
                                                borderBottom: `1px solid ${theme.border}`,
                                                background: groupBg,
                                            }}>
                                                {showBulkSelect && (
                                                    <td style={{ padding: '10px 12px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => toggleSelectOne(p.id, p)}
                                                            style={{ cursor: 'pointer', width: '15px', height: '15px' }}
                                                        />
                                                    </td>
                                                )}
                                                <td style={{ padding: '10px 12px', ...truncate }}>
                                                    <span style={{
                                                        fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, fontSize: '0.78rem',
                                                        color: theme.dark ? '#22d3ee' : '#1d4ed8',
                                                    }}>{p.mv_file_number}</span>
                                                </td>
                                                {showSiteCode && (
                                                    <>
                                                        <td style={{ padding: '10px 12px', ...truncate }}>
                                                            {p.site_code
                                                                ? <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.78rem', fontWeight: 600, color: theme.textPrimary }}>{p.site_code}</span>
                                                                : <span style={{ color: theme.textMuted }}>—</span>}
                                                        </td>
                                                        <td style={{ padding: '10px 12px', color: theme.textMuted, ...truncate }}>{p.site_name || '—'}</td>
                                                    </>
                                                )}
                                                <td style={{ padding: '10px 12px', color: theme.textPrimary, ...truncate }}>{p.owner_name}</td>
                                                <td style={{ padding: '10px 12px', ...truncate }}>
                                                    {p.plate_number ? (
                                                        <span style={{
                                                            background: theme.plateBg, border: `1.5px solid ${theme.plateBorder}`,
                                                            borderRadius: '6px', padding: '2px 6px',
                                                            fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, fontSize: '0.78rem',
                                                            color: theme.plateText, whiteSpace: 'nowrap',
                                                        }}>{p.plate_number}</span>
                                                    ) : <span style={{ color: theme.textMuted }}>—</span>}
                                                </td>
                                                <td style={{ padding: '10px 12px', color: theme.textMuted, ...truncate }}>
                                                    {[p.brand, p.model].filter(Boolean).join(' ') || '—'}
                                                </td>
                                                <td style={{ padding: '10px 12px', ...truncate }}>
                                                    <span style={{
                                                        background: sc.bg, color: sc.color, border: `1px solid ${sc.border}`,
                                                        borderRadius: '20px', padding: '2px 8px', fontSize: '0.68rem', fontWeight: 600, whiteSpace: 'nowrap',
                                                    }}>{p.status}</span>
                                                </td>
                                                <td style={{ padding: '10px 12px', color: theme.textMuted, ...truncate }} title={p.claim_location || ''}>{p.claim_location || '—'}</td>
                                                <td style={{ padding: '10px 12px', color: theme.textMuted, ...truncate }}>{p.assigned_dealer_name || '—'}</td>
                                                <td style={{ padding: '10px 12px', color: theme.textMuted, fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                                                    {new Date(p.updated_at).toLocaleDateString()}
                                                </td>
                                                {canClaim && (
                                                    <td style={{ padding: '10px 12px' }}>
                                                        {(() => {
                                                            const isClaiming = claimingIds.has(p.id);
                                                            return (
                                                                <button
                                                                    onClick={() => handleToggleClaim(p.id, p.is_claimed)}
                                                                    disabled={isClaiming}
                                                                    title={p.is_claimed ? 'Mark as unclaimed' : 'Mark as claimed'}
                                                                    style={{
                                                                        display: 'flex', alignItems: 'center', gap: '4px',
                                                                        background: p.is_claimed ? 'rgba(16,185,129,0.12)' : 'transparent',
                                                                        border: `1px solid ${p.is_claimed ? 'rgba(16,185,129,0.35)' : 'rgba(156,163,175,0.3)'}`,
                                                                        borderRadius: '6px', padding: '4px 8px',
                                                                        cursor: isClaiming ? 'not-allowed' : 'pointer',
                                                                        color: p.is_claimed ? '#10b981' : '#9ca3af',
                                                                        fontSize: '0.72rem', fontWeight: 600, whiteSpace: 'nowrap',
                                                                        opacity: isClaiming ? 0.7 : 1,
                                                                        minWidth: '78px', justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    {isClaiming ? (
                                                                        <div style={{
                                                                            width: '12px', height: '12px', borderRadius: '50%',
                                                                            border: '2px solid currentColor',
                                                                            borderTopColor: 'transparent',
                                                                            animation: 'spin 0.7s linear infinite',
                                                                        }} />
                                                                    ) : (
                                                                        <>
                                                                            {p.is_claimed ? <IconCheckCircle size={13} /> : <IconCircle size={13} />}
                                                                            {p.is_claimed ? 'Claimed' : 'Unclaimed'}
                                                                        </>
                                                                    )}
                                                                </button>
                                                            );
                                                        })()}
                                                    </td>
                                                )}
                                                {showActions && (
                                                    <td style={{ padding: '10px 12px' }}>
                                                        <div style={{ display: 'flex', gap: '4px' }}>
                                                            {canEdit && (
                                                                <button onClick={() => openEdit(p)} style={{
                                                                    background: 'rgba(59,130,246,0.1)', border: '1px solid rgba(59,130,246,0.2)',
                                                                    borderRadius: '6px', color: '#3b82f6',
                                                                    padding: '4px 8px', cursor: 'pointer', fontSize: '0.72rem', fontWeight: 600,
                                                                }}>Edit</button>
                                                            )}
                                                            {canDelete && (
                                                                <button onClick={() => handleDelete(p.id)} style={{
                                                                    background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)',
                                                                    borderRadius: '6px', color: '#ef4444',
                                                                    padding: '4px 8px', cursor: 'pointer', fontSize: '0.72rem', fontWeight: 600,
                                                                }}>Delete</button>
                                                            )}
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>

                                        </React.Fragment>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Pagination + rows-per-page — stays rendered (not hidden) while loading,
                    just disabled, so the layout doesn't jump around on every fetch. */}
                {total > 0 && (
                    <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        marginTop: '14px', flexWrap: 'wrap', gap: '12px',
                    }}>
                        {/* Left: record count + rows-per-page */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
                            <span style={{ fontSize: '0.8rem', color: theme.textMuted }}>
                                Showing <strong style={{ color: theme.textPrimary }}>{firstItem}–{lastItem}</strong> of{' '}
                                <strong style={{ color: theme.textPrimary }}>{total}</strong> records
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <span style={{ fontSize: '0.72rem', color: theme.textMuted, marginRight: '2px' }}>Rows:</span>
                                {PAGE_SIZE_OPTIONS.map(opt => (
                                    <button key={opt} onClick={() => handlePageSize(opt)} disabled={loading} style={{
                                        minWidth: '34px', height: '26px', borderRadius: '5px', padding: '0 6px',
                                        border: `1px solid ${opt === pageSize ? '#2563eb' : theme.border}`,
                                        background: opt === pageSize ? '#2563eb' : 'transparent',
                                        color: opt === pageSize ? '#fff' : theme.textMuted,
                                        fontSize: '0.72rem', fontWeight: opt === pageSize ? 700 : 400,
                                        cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1,
                                    }}>{opt}</button>
                                ))}
                            </div>
                        </div>

                        {/* Right: page navigation */}
                        {totalPages > 1 && (
                            <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                <button onClick={() => goToPage(page - 1)} disabled={page === 1 || loading} style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    width: '32px', height: '32px', borderRadius: '6px', border: `1px solid ${theme.border}`,
                                    background: 'transparent', color: page === 1 ? theme.textMuted : theme.textPrimary,
                                    cursor: (page === 1 || loading) ? 'not-allowed' : 'pointer', opacity: (page === 1 || loading) ? 0.4 : 1,
                                }}><IconChevronLeft size={14} /></button>
                                {pageNumbers.map((pg, i) => (
                                    pg === '...' ? (
                                        <span key={`e-${i}`} style={{
                                            width: '32px', height: '32px', display: 'flex',
                                            alignItems: 'center', justifyContent: 'center',
                                            color: theme.textMuted, fontSize: '0.85rem',
                                        }}>…</span>
                                    ) : (
                                        <button key={pg} onClick={() => goToPage(pg)} disabled={loading} style={{
                                            width: '32px', height: '32px', borderRadius: '6px',
                                            border: `1px solid ${pg === page ? '#2563eb' : theme.border}`,
                                            background: pg === page ? '#2563eb' : 'transparent',
                                            color: pg === page ? '#ffffff' : theme.textPrimary,
                                            cursor: loading ? 'not-allowed' : 'pointer', fontSize: '0.82rem', fontWeight: pg === page ? 700 : 400,
                                            opacity: loading ? 0.6 : 1,
                                        }}>{pg}</button>
                                    )
                                ))}
                                <button onClick={() => goToPage(page + 1)} disabled={page === totalPages || loading} style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    width: '32px', height: '32px', borderRadius: '6px', border: `1px solid ${theme.border}`,
                                    background: 'transparent', color: page === totalPages ? theme.textMuted : theme.textPrimary,
                                    cursor: (page === totalPages || loading) ? 'not-allowed' : 'pointer', opacity: (page === totalPages || loading) ? 0.4 : 1,
                                }}><IconChevronRight size={14} /></button>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Add / Edit modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <div style={{
                    background: theme.bgCard, border: `1px solid ${theme.border}`,
                    borderRadius: '14px', color: theme.textPrimary,
                }}>
                    <div style={{
                        padding: '18px 24px', borderBottom: `1px solid ${theme.border}`,
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    }}>
                        <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1.1rem', color: theme.textPrimary, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {selected ? <IconEdit size={16} /> : <IconPlus size={16} />}
                            {selected ? 'Edit Plate Record' : 'Add Plate Record'}
                        </h5>
                        <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', color: theme.textMuted, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <IconClose size={18} />
                        </button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div style={{ padding: '24px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>

                                <div>
                                    <label style={labelStyle}>MV File Number *</label>
                                    <input name="mv_file_number" value={form.mv_file_number} onChange={handle}
                                           required disabled={!!selected} placeholder="e.g. 2312-00012345"
                                           style={{ ...inputStyle, textTransform: 'uppercase', fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }} />
                                </div>

                                <div>
                                    <label style={labelStyle}>Site Code</label>
                                    <input name="site_code" value={form.site_code} onChange={handle}
                                           placeholder="e.g. 0701" disabled={role === 'lto'}
                                           style={{
                                               ...inputStyle, fontFamily: 'JetBrains Mono, monospace', fontWeight: 600,
                                               opacity: role === 'lto' ? 0.6 : 1,
                                               cursor: role === 'lto' ? 'not-allowed' : 'text',
                                           }} />
                                </div>

                                <div style={{ gridColumn: '1 / -1' }}>
                                    <label style={labelStyle}>Site Name</label>
                                    <input name="site_name" value={form.site_name} onChange={handle}
                                           placeholder="e.g. LTO Cebu South" style={inputStyle} />
                                </div>

                                <div style={{ gridColumn: '1 / -1' }}>
                                    <label style={labelStyle}>Plate Number</label>
                                    <input name="plate_number" value={form.plate_number} onChange={handle}
                                           placeholder="e.g. ABC 1234"
                                           style={{ ...inputStyle, textTransform: 'uppercase', fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }} />
                                </div>

                                <div style={{ gridColumn: '1 / -1' }}>
                                    <label style={labelStyle}>Owner Name *</label>
                                    <input name="owner_name" value={form.owner_name} onChange={handle}
                                           required placeholder="Full name of vehicle owner" style={inputStyle} />
                                </div>

                                <div>
                                    <label style={labelStyle}>Vehicle Type</label>
                                    <select name="vehicle_type" value={form.vehicle_type} onChange={handle}
                                            style={{ ...inputStyle, cursor: 'pointer' }}>
                                        <option value="">-- Select type --</option>
                                        {VEHICLE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                                    </select>
                                </div>

                                <div>
                                    <label style={labelStyle}>Brand</label>
                                    <input name="brand" value={form.brand} onChange={handle} placeholder="e.g. Toyota" style={inputStyle} />
                                </div>

                                <div>
                                    <label style={labelStyle}>Model</label>
                                    <input name="model" value={form.model} onChange={handle} placeholder="e.g. Vios" style={inputStyle} />
                                </div>

                                <div>
                                    <label style={labelStyle}>Color</label>
                                    <input name="color" value={form.color} onChange={handle} placeholder="e.g. White" style={inputStyle} />
                                </div>

                                <div>
                                    <label style={labelStyle}>Status *</label>
                                    <select name="status" value={form.status} onChange={handle} required
                                            style={{ ...inputStyle, cursor: 'pointer' }}>
                                        {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                </div>

                                <div>
                                    <label style={labelStyle}>Claim Location</label>
                                    <input name="claim_location" value={form.claim_location} onChange={handle}
                                           placeholder={form.status === 'In Process' ? 'Not applicable for In Process' : 'e.g. LTO Cebu South, Honda Dealership'}
                                           disabled={form.status === 'In Process'}
                                           style={{
                                               ...inputStyle,
                                               opacity: form.status === 'In Process' ? 0.45 : 1,
                                               cursor: form.status === 'In Process' ? 'not-allowed' : 'text',
                                           }} />
                                </div>

                                {form.status === 'At Dealer' && (
                                    <div style={{ gridColumn: '1 / -1' }}>
                                        <label style={labelStyle}>Assign Dealer</label>
                                        <select name="assigned_dealer_id" value={form.assigned_dealer_id} onChange={handle}
                                                style={{ ...inputStyle, cursor: 'pointer' }}>
                                            <option value="">-- Select dealer --</option>
                                            {dealers.length === 0 ? (
                                                <option disabled>No dealers registered yet</option>
                                            ) : dealers.map(d => (
                                                <option key={d.id} value={d.id}>
                                                    {d.dealer_name || d.username} ({d.username})
                                                </option>
                                            ))}
                                        </select>
                                        <div style={{ fontSize: '0.72rem', color: theme.textMuted, marginTop: '4px' }}>
                                            The assigned dealer can mark this plate as claimed.
                                        </div>
                                    </div>
                                )}

                                <div style={{ gridColumn: '1 / -1' }}>
                                    <label style={labelStyle}>Remarks</label>
                                    <textarea name="remarks" value={form.remarks} onChange={handle} rows={3}
                                              placeholder="Optional notes for the owner..."
                                              style={{ ...inputStyle, resize: 'vertical' }} />
                                </div>
                            </div>
                        </div>

                        <div style={{
                            padding: '14px 24px', borderTop: `1px solid ${theme.border}`,
                            display: 'flex', justifyContent: 'flex-end', gap: '10px',
                        }}>
                            <button type="button" onClick={() => setShowModal(false)} style={{
                                background: 'transparent', border: `1px solid ${theme.borderInput}`,
                                borderRadius: '8px', color: theme.textMuted,
                                padding: '9px 16px', cursor: 'pointer', fontSize: '0.875rem',
                            }}>Cancel</button>
                            <button type="submit" disabled={saving} style={{
                                background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                                border: 'none', borderRadius: '8px', color: 'white',
                                padding: '9px 18px', cursor: saving ? 'not-allowed' : 'pointer',
                                fontWeight: 600, fontSize: '0.875rem', opacity: saving ? 0.7 : 1,
                            }}>
                                {saving ? 'Saving...' : selected ? 'Update Record' : 'Add Record'}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Bulk delete confirmation modal */}
            <Modal show={showBulkConfirm} onHide={() => !bulkDeleting && setShowBulkConfirm(false)} centered size="lg">
                <div style={{
                    background: theme.bgCard, border: `1px solid ${theme.border}`,
                    borderRadius: '14px', color: theme.textPrimary,
                }}>
                    <div style={{
                        padding: '18px 24px', borderBottom: `1px solid ${theme.border}`,
                        display: 'flex', alignItems: 'center', gap: '10px',
                    }}>
                        <span style={{ color: '#ef4444', display: 'flex' }}><IconAlertTriangle size={20} /></span>
                        <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1.05rem', color: theme.textPrimary }}>
                            Confirm deletion of {selectedIds.size} record{selectedIds.size !== 1 ? 's' : ''}
                        </h5>
                    </div>

                    <div style={{ padding: '18px 24px' }}>
                        <p style={{ color: theme.textMuted, fontSize: '0.85rem', marginBottom: '14px' }}>
                            This cannot be undone. Double-check the list below before deleting.
                        </p>
                        <div style={{
                            border: `1px solid ${theme.border}`, borderRadius: '10px',
                            maxHeight: '320px', overflowY: 'auto',
                        }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
                                <thead>
                                <tr>
                                    {['MV File No.', 'Plate No.', 'Owner', 'Status', 'Site'].map(h => (
                                        <th key={h} style={{
                                            padding: '8px 12px', textAlign: 'left',
                                            color: theme.textMuted, fontSize: '0.66rem',
                                            fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase',
                                            borderBottom: `1px solid ${theme.border}`,
                                            background: theme.bgCard, position: 'sticky', top: 0,
                                        }}>{h}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {[...selectedRecords.values()].map(p => (
                                    <tr key={p.id} style={{ borderBottom: `1px solid ${theme.border}` }}>
                                        <td style={{ padding: '8px 12px', fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }}>{p.mv_file_number}</td>
                                        <td style={{ padding: '8px 12px', fontFamily: 'JetBrains Mono, monospace' }}>{p.plate_number || '—'}</td>
                                        <td style={{ padding: '8px 12px' }}>{p.owner_name}</td>
                                        <td style={{ padding: '8px 12px' }}>{p.status}</td>
                                        <td style={{ padding: '8px 12px', color: theme.textMuted }}>{p.site_name || p.site_code || '—'}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div style={{
                        padding: '14px 24px', borderTop: `1px solid ${theme.border}`,
                        display: 'flex', justifyContent: 'flex-end', gap: '10px',
                    }}>
                        <button type="button" disabled={bulkDeleting} onClick={() => setShowBulkConfirm(false)} style={{
                            background: 'transparent', border: `1px solid ${theme.borderInput}`,
                            borderRadius: '8px', color: theme.textMuted,
                            padding: '9px 16px', cursor: bulkDeleting ? 'not-allowed' : 'pointer', fontSize: '0.875rem',
                        }}>Cancel</button>
                        <button type="button" disabled={bulkDeleting} onClick={handleBulkDelete} style={{
                            display: 'flex', alignItems: 'center', gap: '6px',
                            background: '#ef4444',
                            border: 'none', borderRadius: '8px', color: 'white',
                            padding: '9px 18px', cursor: bulkDeleting ? 'not-allowed' : 'pointer',
                            fontWeight: 600, fontSize: '0.875rem', opacity: bulkDeleting ? 0.7 : 1,
                        }}>
                            <IconTrash size={14} />
                            {bulkDeleting ? 'Deleting...' : `Delete ${selectedIds.size} Record${selectedIds.size !== 1 ? 's' : ''}`}
                        </button>
                    </div>
                </div>
            </Modal>

            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}
